import { render, staticRenderFns } from "./ModalAvisoPrivacidad.vue?vue&type=template&id=36d221ea"
import script from "./ModalAvisoPrivacidad.vue?vue&type=script&lang=js"
export * from "./ModalAvisoPrivacidad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports